import { createFileRoute, redirect } from '@tanstack/react-router';

import { z } from 'zod';

export const Route = createFileRoute('/unsubscribe')({
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/recommendation/unsubscribe',
      search,
    });
  },
  validateSearch: z.object({
    token: z.string(),
  }),
  component: Index,
});

function Index() {
  return <div>unsubscribe</div>;
}
